import type {GuidedItemsV2} from '../models/models';
import {makeLogger} from '../../../logger/logger';
import type {GuidedRequest} from '../models/cose';

import type {GuidedMiddleware} from '../models/middleware';

const {
  info,
  // debug,
  // warn,
  // err
} = makeLogger({
  pathToCurrentFile: 'components/guided2/middlewares/cache.ts',
});

type cacheKey = {
  guidedRequest: GuidedRequest,
};
const cacheStorage: WeakMap<cacheKey, GuidedItemsV2> = new WeakMap();

type GuidedCacheMiddleware = GuidedMiddleware & {
  status:{
    requests: 0,
    hits: 0,
    miss: 0,
  }
};


const guidedApiCached: GuidedCacheMiddleware = async(params, next)=>{
    // info('Enter cache middleware', {params});
    const cacheKey = {
      guidedRequest: {...params.guidedRequest},
    };
    // info('Cache request with cacheKey:', cacheKey);
    guidedApiCached.status.requests++;

    if(cacheStorage.has(cacheKey)){
      const r = cacheStorage.get(cacheKey);
      // info('Cache found', r);
      guidedApiCached.status.hits++;
      return r;
    }

    // info('Cache not found, will execute call');
    // info('Calling next middleware', {params});

    const result = await next(params);
    cacheStorage.set(cacheKey, result);
    guidedApiCached.status.miss++;

    // info('Returning result', {result});

    return result;
};

guidedApiCached.status = {
  requests: 0,
  hits: 0,
  miss: 0,
};
export default guidedApiCached;
